




















import { Component, Vue } from 'vue-property-decorator'
import TsTable from '@/components/TsTable/TsTable.vue'
import AddNewDialog from '@/views/manage/userManage/addNewDialog.vue'
import DetailDrawer from '@/views/manage/userManage/detailDrawer.vue'
import { getAllActivation, getAllRoles, getTableUsers, viewUserDetail } from '@/api/manage/userManage'

@Component({
  name: 'UserManage',
  components: {
    DetailDrawer,
    AddNewDialog,
    TsTable
  }
})
export default class extends Vue {
  searchParams: any = {}
  showBackBtn = false
  tableData: any = {
    data: [],
    currentPage: 0,
    pageSize: 20,
    total: 0
  }

  tableTitleObj = {
    title: '用户管理',
    options: {
      dropdown: false,
      arr: [
        {
          type: 'add',
          name: '新增'
        }
      ]
    }
  }

  allRolesList = []
  allActivationList = []
  showAddUser = false
  showDetailDrawer = false
  searchFormData = {}
  headerInfo: any = {
    title: '',
    blockList: []
  }

  columns = [
    {
      labelName: '用户姓名',
      type: 'first',
      propName: 'name',
      options: {
        type: 'search'
      }
    },
    {
      labelName: '许可证名称',
      propName: 'activationKey',
      options: {
        type: 'search'
      }
    },
    {
      labelName: '用户账号',
      propName: 'mobile',
      options: {
        type: 'search'
      }
    },
    {
      labelName: '创建时间',
      propName: 'createTime',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'asc',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'desc',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    },
    {
      labelName: '到期日',
      propName: 'effectTime',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'asc',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'desc',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    },
    {
      labelName: '用户状态',
      propName: 'registering',
      options: {
        type: 'select',
        optionArr: [
          {
            label: '已激活',
            id: true
          },
          {
            label: '未激活',
            id: false
          }
        ]
      }
    }
  ]

  mounted () {
    if (this.$route.query.id) {
      this.showBackBtn = true
      this.searchParams.id = this.$route.query.id
    } else {
      this.showBackBtn = false
    }
    this.handleSearch(this.tableData.currentPage, this.tableData.pageSize)
    getAllRoles({}).then(res => {
      if (res.statusCode === 0 && res.success) {
        this.allRolesList = res.data
      }
    })
  }

  handleFilter (tags: any) {
    if (tags.length) {
      this.searchParams = {}
      tags.forEach((item: any) => {
        const key = item.type
        if (item.params.opt.type) { // sort
          this.searchParams.sortField = key
          this.searchParams.direction = item.params.opt.type
        } else if (item.params.opt.label) { // select
          this.searchParams[key] = item.params.opt.id
        } else { // search
          this.searchParams[key] = item.params.opt.value || item.params.opt.type
        }
      })
    } else {
      this.searchParams = {}
    }
    console.log('过滤结果：', tags)
    this.handleSearch(0, this.tableData.pageSize)
  }

  backToUserManage () {
    this.$router.push('/manage/userLicense')
    this.showBackBtn = false
    delete this.searchParams.id
  }

  // 新增
  handleOpenAddDialog () {
    this.showAddUser = true
  }

  handleSizeChange (size: number) {
    this.tableData.pageSize = size
    this.tableData.currentPage = 0
    this.handleSearch(0, size)
  }

  handleCurrentChange (current: number) {
    this.tableData.currentPage = current
    this.handleSearch(current, this.tableData.pageSize)
  }

  handleCloseAddUser (type: any) {
    if (type !== 'noValue') {
      this.handleSearch(this.tableData.currentPage, this.tableData.pageSize)
    }
  }

  handleSearch (page = 0, size = 20) {
    const params = Object.assign({}, this.searchParams, {
      page,
      size
    })
    getTableUsers(params).then(res => {
      if (res.statusCode === 0 && res.success) {
        this.tableData.data = res.data.content || []
        if (this.tableData.data.length) {
          this.tableData.data = this.tableData.data.map((item: any) => {
            item = Object.assign({}, item, {
              createTime: item.createTime ? item.createTime.slice(0, 10) : '',
              effectTime: item.effectTime ? item.effectTime.slice(0, 10) : '',
              registering: item.registering ? '已激活' : '未激活'
            })
            return item
          })
        }
        this.tableData.total = res.data.totalElements
      }
    })
    getAllActivation({}).then(res => {
      if (res.statusCode === 0 && res.success) {
        this.allActivationList = res.data.map((item: any) => {
          item = Object.assign({}, item, {
            name: item.activationKey
          })
          return item
        })
      }
    })
  }

  handleTableFirst (row: any) {
    viewUserDetail({ userId: row.id }).then(res => {
      if (res.statusCode === 0 && res.success) {
        this.searchFormData = res.data
        this.headerInfo = {
          title: row.name,
          status: row.registering,
          blockList: [
            {
              key: '用户实付:',
              value: res.data.totalRoyalty
            },
            {
              key: '创建时间:',
              value: row.createTime ? row.createTime.slice(0, 10) : ''
            },
            {
              key: '最近登录时间:',
              value: row.lastLoginTime ? row.lastLoginTime.slice(0, 10) : ''
            }
          ]
        }
        this.showDetailDrawer = true
      }
    })
  }

  handleCloseDetailDrawer () {
    this.handleSearch(this.tableData.currentPage, this.tableData.pageSize)
  }
}
